module.exports = __webpack_public_path__ + "static/img/de.3e726c2b.svg";